import { FC, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import { RouteName } from '../../../../enums';
import { EntityType } from '../../../../enums/EntityType';
import {
  StageBodyText,
  StageInner,
  StageWrapper,
  StyledSubHeader,
} from '../../../../main/theme';
import { showModal } from '../../../../store/modal';
import ActionBar from '../../../ActionBar/ActionBar';
import FeatureButton, {
  FeatureButtonSize,
} from '../../../FeatureButton/FeatureButton';
import useUser from '../../../../hooks/user/UseUser';
import { ModalTypes } from '../../../Modal/Modal';
import * as SC from '../../styled';

const UserItemAdvancedStage: FC = () => {
  const dispatch = useDispatch();
  const { user } = useUser();
  const history = useHistory();
  const themeContext = useContext(ThemeContext);

  return (
    <StageWrapper>
      <StageInner>
        <StageBodyText>
          These settings should only be changed if you're absolutely positive on
          what they do.
        </StageBodyText>
        <StageBodyText>
          Some of these operations are <strong>irreversible</strong>.
        </StageBodyText>

        <SC.SettingWrapper>
          <StyledSubHeader>Delete User</StyledSubHeader>

          <StageBodyText>
            This will destroy all data. Be absolutely sure you wish to delete
            this user before proceeding.
          </StageBodyText>

          <FeatureButton
            action={() =>
              dispatch(
                showModal({
                  visible: true,
                  modal: ModalTypes.DELETION,
                  additionalProps: {
                    entityType: EntityType.USER,
                    entityId: user?._id,
                    entityName: `${user?.firstName} ${user?.lastName}`,
                  },
                }),
              )
            }
            size={FeatureButtonSize.WIDE}
            color={themeContext.colors.general.red}
            text={'Delete User'}
          />
        </SC.SettingWrapper>
      </StageInner>

      <ActionBar
        backButton={
          <FeatureButton
            action={() => {
              history.push(`${RouteName.USERS}`);
            }}
            size={FeatureButtonSize.WIDE}
            color={themeContext.colors.general.sea}
            text={'Back to Users'}
          />
        }
      />
    </StageWrapper>
  );
};

export default UserItemAdvancedStage;
